<template>
  <v-container class="content">
    <h1>What's new in Riiqo</h1>
    <div class="sxn-features">
      <div class="sxn-features__item" data-release="1.1.1">
        <p>V1.1.1</p>
        <ul>
          <li>
            Bug Fixes
            <ol>
              <li>Fixed issue on Map Dashboard page where the customers pin markers are not displayed.</li>
              <li>Fixed a bug wherein customers cannot be added.</li>
              <li>Reinstated the default server error page.</li>
              <li>Color for iOS top bar is now #1A1D23.</li>
              <li>Fixed Customer types color for MAP and Attribute.</li>
              <li>Fixed search customer click empty search box when hit backspace the cursor is gone.</li>
              <li>Fixed tag color options click away.</li>
              <li>Fixed customer page birthday typing experience and margin and formatting.</li>
              <li>Fixed hide customer page milestone flag button when no milestone created.</li>
              <li>Fixed attribute text popout tray animation and layout.</li>
              <li>Fixed customer page address autocomplete flashing (under observation ).</li>
              <li>Fixed customer birthday not saving.</li>
              <li>Fixed milestone page schedule date 1/1/1970.</li> 
              <li>Fixed milestone page disable state.</li>
              <li>Fixed milestone page message body add firstname has null value.</li>
              <li>Fixed. Unable to add sender email for milestones 3.27.</li>
              <li>Customer list search icon hidden in desktop view.</li>
              <li>Attribute sub left menu fixed in bigger screen.</li>
              <li>Attribute Header Scoop filter update design.</li>
              <li>Advance call connection group list.</li>
              <li>Fixed customer search prevents press enter.</li>
              <li>Fixed milestone not emailing.</li>
              <li>Fixed. When you add a new event on Calendar (Riiqo), It doesn’t reflect/display on the user google calendar.</li>
              <li>Fixed customer list scale function and card layout.</li>
              <li>Update Mobile view</li>
            </ol>
          </li>
          <li>
            Features
            <ol>
              <li>Connection popout tray.</li>
              <li>Add copy calendar url to clipboard.</li>
            </ol>
          </li>
          <li>One-time scripts</li>
        </ul>
        <hr>
      </div>
      <div class="sxn-features__item" data-release="1.1.0">
        <p>V1.1.0</p>
        <ul>
          <li>
            Bug Fixes
            <ol>
              <li>Fixed issue wherein notes were not working for new client users.</li>
              <li>Fixed Import button function on main screen. (Button will open left menu import screen)</li>
              <li>Fixed Event update/create moving to another date</li>
              <li>Fixed event popout invited user marked as "organizer" change to "you";</li>
              <li>Fixed Attribute status dropdown reactivity</li>
            </ol>
          </li>
          <li>
            Features
            <ol>
              <li>File download capability.</li>
              <li>Upgraded Laravel to 6.18</li>
              <li>File movement analytics are grouped by weekday.</li>
              <li>Lead types</li>
              <li>Client user permissions were updated (Backend).</li>
            </ol>
          </li>
          <li>One-time scripts</li>
        </ul>
        <hr>
      </div>
      <div class="sxn-features__item" data-release="1.0.9">
        <p>V1.0.9</p>
        <ul>
          <li>
            Bug Fixes
            <ol>
              <li>Client section attribute reorder is now evident in customer pages.</li>
              <li>Storage Dragging out safari changed native drop function to data watcher.</li>
              <li>Calendar Notif count fixed.</li>
              <li>Attribute edit mode disable textbox or textarea to be able to drag the attribute.</li>
              <li>Change invite user/customer design.</li>
            </ol>
          </li>
          <li>
            Features
            <ol>
              <li>Storage customer files API ready.</li>
              <li>File change ownership API ready.</li>
              <li>Client users with level of ADMIN can now view files.</li>
              <li>Storage client user file API ready.</li>
              <li>Admin user file list.</li>
              <li>Admin customer file list.</li>
              <li>Customer page tag auto suggest word with highlight.</li>
            </ol>
          </li>
          <li>One-time scripts</li>
        </ul>
        <hr>
      </div>
      <div class="sxn-features__item">
        <p>V1.0.8</p>
        <ul>
          <li>
            Bug Fixes
            <ol>
              <li>A user with session expired is now automatically logged out.</li>
              <li>Safari attribute adding.</li>
              <li>Calendar popup layout and auto tag customer.</li>
              <li>PWA bug where manifest does not see the service worker is now fixed.</li>
              <li>PWA push notification was reinstated.</li>
              <li>Attribute Safari drag drop fixes.</li>
              <li>Calendar page filter dropdown.</li>
              <li>Client attribute placeholder added.</li>
              <li>Customer attribute section custtype setting removed.</li>
              <li>Calendar event limit fixed.</li>
              <li>Fixed dragging out of the folder safari.</li>
              <li>Fixed select box activating event dragging a file.</li>
              <li>Fixed milestone icon and cursor.</li>
              <li>Fixed attribute hover.</li>
              <li>Fixed Storage progress bar.</li>
              <li>Fixed folder thumbnails.</li>
            </ol>
          </li>
          <li>
            Features
            <ol>
              <li>All system features</li>
              <li>Icons are now updated</li>
              <li>Calendar notification</li>
              <li>Added new feature for upload files with file preview and progress bar each file.</li>
              <li>Add feature file load batch by 20 files, file will continue to load while scrolling.</li>
              <li>Add folder on search result.</li>
              <li>RIIQO is now Riiqo.</li>
            </ol>
          </li>
          <li>One-time scripts</li>
        </ul>
        <hr>
      </div>
      <div class="sxn-features__item">
        <p>V1.0.7</p>
        <ul>
          <li>
            Bug Fixes
            <ol>
              <li>Email body does not show HTML tags anymore</li>
              <li>Fixed erroneous chart endpoint totals.</li>
              <li>Milestone step modal slider</li>
              <li>Header calendar fix alignment</li>
              <li>Customer long customer name lastname next line</li>
              <li>Storage activity timestamp is now fixed</li>
              <li>Milestone calendar date dynamic border color</li>
              <li>Purchase invoice logo cut is now fixed</li>
              <li>Pdf invoice date format fixed</li>
            </ol>
          </li>
          <li>
            Features
            <ol>
              <li>Job for moving milestones now set to America/Denver timezone and will run at 1AM daily. This was configured to run in the background so that the system will not lock.</li>
              <li>Chart endpoints now accept the end date.</li>
              <li>Search persistent on customer list  were you have to click the x button to clear search result.</li>
              <li>Client and customer attribute drag anywhere.</li>
              <li>System is now installable via PWA.</li>
              <li>S3 CORS is now properly defined.</li>
              <li>System can now receive push notifications.</li>
              <li>Storage: Folder names are now included in Search.</li>
            </ol>
          </li>
          <li>One-time scripts</li>
        </ul>
        <hr>
      </div>
      <div class="sxn-features__item">
        <p>V1.0.6</p>
        <ul>
          <li>
            Features
            <ol>
              <li>Updated page policies to include client users. It was previously limited to RIIQO and client admins.</li>
              <li>User local timezone helper created. To be implemented.</li>
              <li>Left menu customer type, no color option added.</li>
              <li>Canadian addresses can now be entered in a customer page.</li>
            </ol>
          </li>
          <li>
            Fixes
            <ol>
              <li>Customer phone deletion is now possible.</li>
              <li>First Name / Last Name / Company Name - Cut letters and double word is now fixed.</li>
              <li>Birth Date formatting is now correct.</li>
              <li>Adding tags reactivity.</li>
              <li>Purchase layout fixes.</li>
              <li>Login UI fixes.</li>
              <li>Clickable section title.</li>
              <li>Customer search is now fixed. This includes first name and last name bug fix.</li>
              <li>Map customer types show the correct list and colors.</li>
              <li>List view is now fixed.</li>
              <li>Left menu issue  fixed (hover background color).</li>
              <li>Milestone step modal gray gap is now fixed.</li>
              <li>Media attribute reactivity upload/ delete.</li>
              <li>Purchase invoice modal can’t scroll to top is now fix.</li>
            </ol>
          </li>
        </ul>
        <hr>
      </div>
      <div class="sxn-features__item">
        <p>V1.0.5</p>
        <ul>
          <li>One-time scripts</li>
        </ul>
        <hr>
      </div>
      <div class="sxn-features__item">
        <p>V1.0.4</p>
        <ul>
          <li>
            Bug Fixes
            <ol>
              <li>Fixed client online/offline chat status and update chat widget button icon</li>
              <li>Fixed client ‘null’ object response from API Active User.</li>
            </ol>
          </li>
          <li>
            Controllers
            <ol>
              <li>app/Http/Controllers/Api/ChatController.php</li>
              <li>app/Http/Controllers/Api/UserController.php</li>
            </ol>
          </li>
        </ul>
        <hr>
      </div>
      <div class="sxn-features__item">
        <p>V1.0.3</p>
        <ul>
          <li>Packages Installed</li>
          <li>One-time scripts</li>
          <li>
            Purchase Invoice
            <ol>
              <li>Purchase Modal Layout</li>
              <li>PDF Invoice Layout</li>
              <li>Issue / Due Date Date Masking</li>
            </ol>
          </li>
          <li>
            Storage
            <ol>
              <li>Upgrade Plans</li>
            </ol>
          </li>
          <li>
            Milestone
            <ol>
              <li>Bug Fixes</li>
              <li>Email toggle</li>
              <li>Rich text</li>
            </ol>
          </li>
        </ul>
        <hr>
      </div>
      <div class="sxn-features__item">
        <p>V1.0.2</p>
        <ul>
          <li>Packages Installed</li>
          <li>One-time Scripts</li>
          <li>
            Login
            <ol>
              <li>Fix tabbing issue.</li>
              <li>Added auto focus on tab.</li>
            </ol>
          </li>
          <li>
            Schedule
            <ol>
              <li>Fullcalendar upgrade to v4.</li>
              <li>Separate component for event.</li>
              <li>Event drag n drop fixes.</li>
              <li>Layout fixes for week and day view.</li>
            </ol>
          </li>
          <li>
            Media Attribute
            <ol>
              <li>Media gallery added with slide.</li>
              <li>Media gallery full view width slide.</li>
            </ol>
          </li>
          <li>
            Storage
            <ol>
              <li>Full view no menus.</li>
              <li>File thumbnail scroll spy</li>
              <li>Drag Drop upload progress bar</li>
              <li>Contributors file permission</li>
            </ol>
          </li>
        </ul>
        <hr>
      </div>
      <div class="sxn-features__item">
        <p>V1.0.1</p>
        <ul>
          <li>
            Customer
            <ol>
              <li>Updates in header calendar scroll (event gradient, current date center position, etc...).</li>
            </ol>
          </li>
          <li>
            Storage
            <ol>
              <li>Majority of the endpoints have been developed.</li>
              <li>API implementation.</li>
              <li>Bug Fixing.</li>
              <li>Style adjustment.</li>
            </ol>
          </li>
          <li>
            Purchase
            <ol>
              <li>Discount computation bug fixing.</li>
              <li>Style adjustment.</li>
            </ol>
          </li>
          <li>
            Schedule
            <ol>
              <li>Calendar styling.</li>
              <li>Week view</li>
              <li>Day view</li>
              <li>Date picker for week and day view.</li>
              <li>Option to select gradient color for event.</li>
              <li>Gradient event dot.</li>
            </ol>
          </li>
          <li>
            Attributes
            <ol>
              <li>Drop-down variables</li>
            </ol>
          </li>
          <li>
            Customer Media
            <ol>
              <li>Endpoint for customer media is ready.</li>
            </ol>
          </li>
          <li>Packages Installed</li>
          <li>One Time Scripts</li>
        </ul>
        <hr>
      </div>
    </div>
  </v-container>
</template>

<script>
import { bus } from '../../main';
export default {
  name: 'updateFeatures',

  data: () => ({
    
  }),
  mounted() {
    bus.$emit('update-route', this.$route);
  },
  method: {

  }
};
</script>
